import { render, staticRenderFns } from "./ChangeItem.vue?vue&type=template&id=3d06b176"
import script from "./ChangeItem.vue?vue&type=script&lang=js"
export * from "./ChangeItem.vue?vue&type=script&lang=js"
import style0 from "./ChangeItem.vue?vue&type=style&index=0&id=3d06b176&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports